import { useMutation } from '@tanstack/react-query';

import { useSnackbar } from 'notistack';
import { IncidentClient, ProblemDetails, IncidentWorkflowStatus } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const incidentClient = new IncidentClient(apiBaseUrl);

function useGetIncidentWorkflowStatus() {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation<IncidentWorkflowStatus, ProblemDetails, number>({
    mutationKey: [queryKeys.Incident.GetIncidentWorkflowStatus],
    mutationFn: (id: number) => incidentClient.getIncidentWorkflowStatus(id),
    onError: (error) => {
      const statusMessage = error.status === 404
        ? 'Some of the workflow status data could not be found on the server. Please refresh the page and try again.'
        : 'An unexpected error has occurred.';

      enqueueSnackbar(statusMessage, { variant: 'error', persist: false });
    },
  });
}

export default useGetIncidentWorkflowStatus;
